import format from 'date-fns/format';
import React, { FunctionComponent, useMemo } from 'react';
import { Fade } from 'react-awesome-reveal';
import { getLocaleByCode } from '../../../../utils/locale';
import { blogArticleUrl } from '../../../../utils/utils';
import { IEmployeeBoxProps } from '../../../employee-box/employee-box';
import { InternalLink } from '../../../internal-link/internal-link';
import { ArticleAuthorSmallBox } from '../../../article-author-small-box/article-author-small-box';
import styles from './featured-article-item.module.scss';

export interface IFeaturedArticleItemProps {
  language: string;
  id: string;
  title: string;
  summary: string;
  author: IEmployeeBoxProps;
  slug: string;
  publicationDate: string;
  categoryUrl: string;
  categoryName: string;
  image: {
    url: string;
    name: string;
  };
  featured: boolean;
  isAnimated: boolean;
}

export const FeaturedArticleItem: FunctionComponent<IFeaturedArticleItemProps> = props => {
  const {
    language,
    title,
    summary,
    author,
    slug,
    publicationDate,
    categoryUrl,
    image: { url, name: alt },
    isAnimated
  } = props;

  const articleUrl = blogArticleUrl(slug, categoryUrl);
  const locale = useMemo(() => getLocaleByCode(language), [language]);
  const dateToDisplay = format(new Date(publicationDate), 'dd MMMM yyyy', {
    locale
  });
  const content = (
    <InternalLink className={styles.articleWrapper} url={articleUrl}>
      <article className={styles.container}>
        <div className={styles.contentWrapper}>
          <div className={styles.articleInfo}>
            <div className={styles.date}>{dateToDisplay}</div>
            <div className={styles.content}>
              <h3 className={styles.title}>{title}</h3>
              <p className={styles.summary}>{summary}</p>
            </div>
            <ArticleAuthorSmallBox author={author} />
          </div>
          <div className={styles.imageWrapper}>
            <img className={styles.articleImage} src={url} alt={alt} />
          </div>
        </div>
      </article>
    </InternalLink>
  );

  return (
    <React.Fragment>
      {isAnimated ? <Fade triggerOnce>{content}</Fade> : content}
    </React.Fragment>
  );
};
